"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../assets/css/font-face.css");

require("./Currency.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Currency = function Currency(_ref) {
  var value = _ref.value,
      kformat = _ref.kformat;

  if (kformat && value > 999) {
    return _react.default.createElement("span", {
      className: "currency"
    }, (value / 1000).toFixed(1) + 'k');
  }

  return _react.default.createElement("span", {
    className: "currency"
  }, parseFloat(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }));
};

Currency.defaultProps = {
  value: 0
};
Currency.propTypes = {
  /** Valor para ser convertido em reais (int/float) */
  value: _propTypes.default.number.isRequired
};
var _default = Currency;
exports.default = _default;